import { render, staticRenderFns } from "./TaksitlendirmeForm.vue?vue&type=template&id=a9cf4942"
import script from "./TaksitlendirmeForm.vue?vue&type=script&lang=ts"
export * from "./TaksitlendirmeForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports